module.exports = __webpack_public_path__ + "248386f3aed921be7da527fb4347f61f.png";